module.exports = __webpack_public_path__ + "img/framework.08130605.png";